export default function EmptyFactsheet(){
    return <div className="empty grid center">
        <p>Search food to see its nutritent factsheet</p>
    </div>
}